import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { TopicViewsReport } from '@portal-core/output-analytics/models/output-analytics-topic-views-report.model';

@CollectionStateSelectors({
  stateType: TopicViewsReportState
})
@State<TopicViewsReportState>({
  name: TopicViewsReportState.source,
})
@Service({ autoProvided: false })
export class TopicViewsReportState extends CollectionStateBase {
  static override source = 'TopicViewsReports';
  getSource(): string {
    return TopicViewsReportState.source;
  }
}

@Service()
export class TopicViewsReportDataService extends CollectionDataServiceBase<TopicViewsReport> {
  protected readonly stateType = TopicViewsReportState;
}
